export default __webpack_public_path__ + "static/media/love.7e98336a.png";